import LabelEditStep from './LabelEditStep';

export default LabelEditStep;
